import { MOBILE_CONNECTION_START, MOBILE_CONNECTION_STOP } from "./constants";

const initialState = {
  isMobileConnected: false,
  error: "",
};

const reducer = function groupReducer(state = initialState, action) {
  switch (action.type) {
    case MOBILE_CONNECTION_START: {
      return {
        ...state,
        isMobileConnected: true,
      };
    }

    case MOBILE_CONNECTION_STOP: {
      return {
        ...state,
        isMobileConnected: false,
      };
    }

    default:
      return state;
  }
};

export default reducer;
